<template>
    <div style="padding:0;">
        <iframe :src="'https://kd.kyw4y0s.com/nc/saas/TF/bm/placeOrder___.html?pid=' + this.query.pid + '&eid=' + this.query.eid + '&version=' + this.query.version"
                width="100%" style="height:100%;"></iframe>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                query: {
                    pid: this.$route.query.pid,
                    eid: this.$route.query.eid,
                    version: this.$route.query.version,
                },
            }
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
</style>
